import { DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { formatCommonDate } from '../../../utils/dateUtils';
import { getInitialConditionalAction, getRouteToCallback } from '../../../utils/formattersUtils';
import styles from './DateRenderer.module.scss';

const cx = classNames.bind(styles);

const DateRenderer: DataItemFormatter<string, ReactElement, { label?: string; onItemClick? }> = ({
  value: date,
  item,
  configuration,
  props,
  row,
}) => {
  const { isDisabled, isHovered } = row;
  const routeToCallback = getRouteToCallback(configuration, item);
  const initialConditionalAction = getInitialConditionalAction(configuration, row, props, item);

  return configuration ? (
    <Link
      to={routeToCallback}
      className={cx('body', { 'gray-out': isDisabled && isHovered }, configuration.className)}
      onClick={initialConditionalAction}
      tabIndex={-1}
      data-testid="date-renderer"
    >
      {props?.label ? `${props.label} ` : null}
      {formatCommonDate(date)}
    </Link>
  ) : (
    <span className={cx('body')}>
      {props?.label ? `${props.label} ` : null}
      {formatCommonDate(date)}
    </span>
  );
};

export default DateRenderer;
